export const EXTERNAL_API = '{{export_service_url}}';
